import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { TranslocoService } from '@jsverse/transloco';
import { ROUTES } from '@shared/constants/routes/routes.constants';
import { ContextEnum } from '@shared/enums/context.enum';
import { SnackbarService } from '@shared/service/snackbar/snackbar.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

/* tslint:disable */
@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  private snackbarService = inject(SnackbarService);
  private router = inject(Router);
  private readonly translocoService = inject(TranslocoService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap({
        next: (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            // continue
          }
        },
        error: (err: any) => {
          if (err instanceof HttpErrorResponse) {
            switch (err.status) {
              case 401: {
                // Logout didn't work with PingFederate, so we can't do anything here
                break;
              }
              case 404: {
                // Pass the error if it occurred during an update operation
                if (err.error?.context === ContextEnum.UPDATE || err.url?.includes('/assets/')) {
                  break;
                }

                this.router?.navigateByUrl('/' + ROUTES.NOT_FOUND);
                break;
              }
              case 500:
              case 504: {
                this.snackbarService.error(this.translocoService.translate('somethingWentWrong'));
                break;
              }
              case 503: {
                this.router?.navigateByUrl('/' + ROUTES.SERVER_ERROR);
                break;
              }
            }
          }
        }
      })
    );
  }
}
